/**
 * @description: 仓库管理-库存调拨
 * @author: fire (2017-10-30) 
 * @update: hwx
 * @update: lyr(2022-03-16)
 */
<template>
	<div class="exchange-stock">
		<div class="purchase_list" v-show="!showdetail">
			<div class="row row-margin">
				<button type="button" class="btn btn-flat btn-middle btn-orange" id="add-exchange-stock" @click="addExchangeStock" v-if="hasAddPrivilege">新增库存调拨单</button>
			</div>
			<div class="row row-margin">
				<label class="list-label-2">时间:</label>
				<div class="col-md-3" style="width: 335px">
					<div id="time-wrapper" @click="clearDate" ref="time">
						<input type="text" class="form-control laydate-icon" id="start-time" :value="startTime" style="display:inline-block;width: 145px;"> -
						<input type="text" class="form-control laydate-icon" id="end-time" :value="endTime" style="display:inline-block;width: 145px;">
					</div>
				</div>
				<label class="list-label-4">调出门店:</label>
				<div class="col-md-2 ct-col">
					<select class="form-control" ref="fromShop" data-placeholder="请选择调出门店"></select>
				</div>
				<label class="list-label-4">调出仓库:</label>
				<div class="col-md-2">
					<div class="input-group">
						<input type="text" id="from_stock" class="form-control" ref="from_stock" placeholder="请选择调出仓库" @blur="fromnowCon" />
						<div class="input-group-btn">
							<ul class="dropdown-menu dropdown-menu-right" role="menu" ref="fromDown"></ul>
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<label class="list-label-4">调入门店:</label>
				<div class="col-md-2 ct-col">
					<select class="form-control" ref="toShop" data-placeholder="请选择调入门店"></select>
				</div>
				<label class="list-label-4">调入仓库:</label>
				<div class="col-md-2">
					<div class="input-group">
						<input type="text" id="to_stock" class="form-control" ref="to_stock" placeholder="请选择调入仓库" @blur="tonowCon" />
						<div class="input-group-btn">
							<ul class="dropdown-menu dropdown-menu-right" role="menu" ref="toDown"></ul>
						</div>
					</div>
				</div>
				<div class="pull-right">
					<button type="button" class="btn btn-flat btn-small btn-orange" id="query" @click="queryList">查询</button>
				</div>
			</div>
			<div class="table-responsive">
				<table id="purchase-list" class="table table-bordered table-hover" data-pagination="true" ref="purchaselist"></table>
			</div>
		</div>
		<!-- detail -->
		<div class="detail-panel" v-show="showdetail">
			<div class="row">
				<div class="col-md-2" v-show="visible">
					<button type="button" class="btn btn-flat btn-middle btn-orange" id="allotSave" @click="submitPurchase">保存</button>
				</div>
				<div class="col-md-2">
					<button type="button" class="btn btn-flat btn-middle btn-orange" id="back" @click="backList">返回</button>
				</div>
				<div class="col-md-2" v-show="!visible">
					<button type="button" class="btn btn-flat btn-middle btn-orange" @click="getExportSet">导出</button>
				</div>
			</div>
			<div class="gray-head">
				<div class="page-title">{{pagetitle}}</div>
				<div class="comment">
					注释：库存调拨单指商品从调出仓库的库存增加到调入仓库的库存</br>
					调拨数量支持乘法输入。例如输入12*3，系统自动算出等于36
				</div>
				<div class="gray-center">
					<div class="col-md-12">
						<label class="col-md-1" v-show="showNumandTime" style="width: 45px;padding: 0;">单号：</label>
						<span class="col-md-3" v-show="showNumandTime">{{theDetail.number}}</span>
						<label class="col-md-1" style="width: 70px;padding: 0;">调出门店：</label>
						<div class="col-md-3 ct-col">
							<select class="form-control" id="detailshop" data-placeholder="请选择" ref="detailshop">
								
							</select>
						</div>
						<label class="col-md-1" style="width: 70px;padding: 0;">调出仓库：</label>
						<div class="col-md-3 ct-col">
							<select class="form-control" id="detail_from_stock" data-placeholder="请选择" ref="detail_from_stock">
								<option value=""></option>
							</select>
						</div>
					</div>
					<div class="col-md-12">
						<label class="col-md-1" v-show="showNumandTime" style="width: 45px;padding: 0;">时间：</label>
						<span class="col-md-3" v-show="showNumandTime">{{theDetail.create_time}}</span>
						<label class="col-md-1" style="width: 70px; padding: 0;">调入门店：</label>
						<div class="col-md-3 ct-col">
							<select class="form-control" id="detail_to_shop" data-placeholder="请选择" ref="detail_to_shop">
								
							</select>
						</div>
						<label class="col-md-1" style="width: 70px;padding: 0;">调入仓库：</label>
						<div class="col-md-3 ct-col">
							<select class="form-control" id="detail_to_stock" data-placeholder="请选择" ref="detail_to_stock">
								<option value=""></option>
							</select>
						</div>
					</div>
					<div class="col-md-12" style="margin: 0 0 20px;">
						<label class="col-md-1" style="width: 70px; padding: 0;" v-show="showDet">调拨总额：</label>
						<span class="col-md-3" style="width: 205px;" v-show="showDet">{{theDetail.buyingprice_total}}</span>
						<label class="col-md-1" style="width: 70px; padding: 0;">备注：</label>
						<div class="col-md-3" style="margin: 6px 0 0;">
							<input type="text" class="form-control" placeholder="请输入备注" v-model="allot_remark" ref="allot_remark" @blur="onRemarkBlur">
						</div>
					</div>
					<div v-show="visible||(!visible&&editVisible)" style="clear: both; padding: 20px 0;">
						<button type="button" class="btn btn-flat btn-middle btn-orange" id="add-goods" @click="addGoods">添加商品</button>
					</div>
				</div>

			</div>
			<!-- div class="col-md-12 title" v-show="showDetailTable">xxxxxxxxxxxxxxxxxxxxxxxx</div -->
			<div class="table-responsive">
				<table id="detail-list" class="table table-bordered table-hover" data-pagination="true" ref="detaillist" style="margin-top:20px"></table>
			</div>
			<!-- 导出设置弹窗 -->
			<div class="ele-hide" ref="export_alert">
				<div class="set-export sel-seldiv">
					<h3>请选择导出报表需要的显示的字段</h3>
					<ul class="set-area clearfix">
						<li>
							<input type='checkbox' v-model='export_allcheck' @click='exportCheckedAll'>
							<label>全选</label>
						</li>
						<li>
							<input type="checkbox" v-model='export_checkModel' value="goods_name">
							<label>商品名称</label>
						</li>
						<li>
							<input type="checkbox" v-model='export_checkModel' value="goods_unit_name">
							<label>商品单位</label>
						</li>
						<li>
							<input type="checkbox" v-model='export_checkModel' value="goods_type_name">
							<label>商品类型</label>
						</li>
						<li>
							<input type="checkbox" v-model='export_checkModel' value="quantity">
							<label>调拨数量</label>
						</li>
						<li>
							<input type="checkbox" v-model='export_checkModel' value="buyingprice">
							<label>进货单价</label>
						</li>
						<li>
							<input type="checkbox" v-model='export_checkModel' value="buyingprice_total">
							<label>进货价合计</label>
						</li>
					</ul>
					<h3>请选择导出报表的文件格式</h3>
					<ul class="clearfix">
						<li>
							<input type="radio" v-model='export_type' value="1">
							<label>excel表格</label>
						</li>
						<li>
							<input type="radio" v-model='export_type' value="2">
							<label>pdf文件</label>
						</li>
					</ul>
				</div>
			</div>

			<!-- pop -->
			<div class="add-goods" ref="addgoods">
				<el-radio-group v-model="pop_add_radio">
				    <el-radio :label="1">按商品</el-radio>
				    <el-radio :label="2">按商品分类</el-radio>
				</el-radio-group>
				<div class="by-goods" v-show="pop_add_radio=='1'">
					<div class="col-md-12">
						<div class="col-md-4 ct-col">
							<select class="form-control" id="good-type" data-placeholder="商品类型" ref="goodtype">
								<option value=""></option>
							</select>
						</div>
						<div class="col-md-6" style="padding-right: 0;">
							<input type="text" class="form-control" id="good-name" placeholder="请输入商品名称" ref="goodname" @keyup.13="queryGoods" />
						</div>
						<div class="col-md-2">
							<button type="button" class="btn btn-flat btn-small btn-orange" id="pop-querry" @click="queryGoods">查询</button>
						</div>
					</div>
					<div class="table-responsive" style="margin-top: 20px;">
						<table id="goods-list" class="table table-bordered table-hover" data-pagination="true" ref="exchangeStockList" style="margin-top:20px"></table>
					</div>
					<div class="row btns">
						<button type="button" class="btn btn-flat btn-small btn-orange pop-save" @click="saveGoods">保存</button>
						<button type="button" class="btn btn-flat btn-small btn-gray" @click="closeLayer">取消</button>
					</div>
				</div>
				<div class="by-types" v-show="pop_add_radio=='2'">
					<div class="checkbox-wrapper">
			            <el-checkbox v-model="checkAllGoodsType" @change="handleCheckAllChange">全选</el-checkbox>
			            <el-checkbox-group v-model="choosed_goods_type" @change="handleCheckedGoodsTypeChange">
			                <el-checkbox v-for="item in goods_type_list" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
			            </el-checkbox-group>
					</div>
					<div class="row btns">
						<button type="button" class="btn btn-flat btn-small btn-orange pop-save" @click="onGoodsTypeSaveClick">保存</button>
						<button type="button" class="btn btn-flat btn-small btn-gray" @click="closeLayer">取消</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	export default {
		name: 'exchange-stock',
		data() {
			return {
				showdetail: false, //控制采购进货详情页显示
				showNumandTime: true, //控制详情页单号和时间的显示
				showDet: false,
				showDetailTable: false, //控制详情页表格标题的显示
				preshopid: "",//下拉框上次选中值
				presupplierid: "",
				pagetitle: "",
				startTime: "",
				endTime: "",
				visible: false, //控制详情页“新增”、“保存”按钮显示
				hasDelPrivilege: false, // 是否有删除权限
				hasEditPrivilege: false, // 是否有修改权限
				hasAddPrivilege: false, // 是否有新增权限
				shopData: {
					value: []
				},
				to_stock: {		// 调出仓库
					value: []
				},
				from_stock: {		// 调入仓库
					value: []
				},
				// supplier: {
				// 	value: []
				// },
				detailshop: [],
				detail_to_stock: [],
				detail_from_stock: [],

				detailsupplier: [],
				theDetail: {	// 
					type: Object
				},
				detail_list: [],
				goodsType_list: [],

				export_allcheck: false,
				c_export_allcheck: false,
				export_checkModel: [],
				export_checkData: ['goods_name', 'goods_unit_name', 'goods_type_name', 'quantity', 'buyingprice', 'buyingprice_total'],
				export_type: 1,
				allot_remark: '',
				editVisible: false,

				pop_add_radio: 1,
				goods_type_list: [],
				checkAllGoodsType: false,
				choosed_goods_type: [], // 选中的商品类型
			}
		},
		watch: {
			export_checkModel: {
				handler: function(val, oldVal) {
					if(this.export_checkModel.length >= this.export_checkData.length) {
						this.export_allcheck = true;
						this.c_export_allcheck = true;
					} else {
						this.export_allcheck = false;
						this.c_export_allcheck = false;
					}
				},
				deep: true
			},
		},
		mounted: function() {
			this.$nextTick(function() {
				this.menu()
				// 日期
				var myDate = new Date();
				this.IntstartTime = myDate;
				this.IntendTime = new Date(myDate.getTime() + 1 * 24 * 3600 * 1000);
				this.IntstartTime.setHours(8, 0);
				this.IntendTime.setHours(8, 0);
				var timStar = new Date(this.IntstartTime),
					year = timStar.getFullYear(),
					month = (timStar.getMonth() + 1) < 10 ? '0' + (timStar.getMonth() + 1) : (timStar.getMonth() + 1),
					day = timStar.getDate() < 10 ? '0' + timStar.getDate() : timStar.getDate(),
					hour = timStar.getHours() < 10 ? '0' + timStar.getHours() : timStar.getHours(),
					minute = timStar.getMinutes() < 10 ? '0' + timStar.getMinutes() : timStar.getMinutes();
				var timEnd = new Date(this.IntendTime),
					yearend = timEnd.getFullYear(),
					monthend = (timEnd.getMonth() + 1) < 10 ? '0' + (timEnd.getMonth() + 1) : (timEnd.getMonth() + 1),
					dayend = timEnd.getDate() < 10 ? '0' + timEnd.getDate() : timEnd.getDate(),
					hourend = timEnd.getHours() < 10 ? '0' + timEnd.getHours() : timEnd.getHours(),
					minuteend = timEnd.getMinutes() < 10 ? '0' + timEnd.getMinutes() : timEnd.getMinutes();
				this.startTime = year + '-' + month + '-' + day + ' ' + hour + ':' + minute;
				this.endTime = yearend + '-' + monthend + '-' + dayend + ' ' + hourend + ':' + minuteend;
				this.innitDate();
				this.innitShopInput();		// 初始化门店输入框
			});
		},
		filters: {
			formateMoney: function(value) {
				if(value < 0) {
					return "0.00";
				} else {
					return(value - 0).toFixed(2);
				}
			}
		},
		methods: {
			menu() {
                let _this = this,
                    menu = {};
                if(!$.isEmptyObject(this.$store.state.menunew)) {
                    menu = JSON.parse(this.$store.state.menunew);
                    $.each(menu, function(k, v) {
                        if(v.id == '543') {
                            menu = v.submenu;
                            $.each(menu, function(m, n) {
                                if(n.name == '库存调拨') {
                                    menu = n.submenu;
                                    $.each(menu, function(x, y) {
                                    	if (y.id == '1056') { // 新增
                                    		_this.hasAddPrivilege = true;
                                    	}
                                    	if (y.id == '1057') { // 修改
                                    		_this.hasEditPrivilege = true;
                                    	}
                                        if(y.id == '1058') { // 删除
                                            _this.hasDelPrivilege = true;
                                        }
                                    });
                                }
                            });
                        }
                    });
                }
            },

			loadStockListCustom: function(id, fun) {
				let _this = this;
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							shop_id: id
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);

				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "PublicData/api_getStoreList",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if( data.response.result_code == "true" ) {
							fun(data.response.result);
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			loadStockList: function(id, num) {
				let _this = this;
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							shop_id: id
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);

				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "PublicData/api_getStoreList",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							if(num == 1) {
								_this.detail_from_stock = [];
								$(_this.$refs.detail_from_stock).html("");
								$.each(data.response.result, function(k, v) {
									_this.detail_from_stock.push({
										id: v.id,
										text: v.name
									});
								});
								$(_this.$refs.detail_from_stock).select2({
									data: _this.detail_from_stock,
									width: '100%'
								});
								$(_this.$refs.detail_from_stock).prop("disabled", false); // 可用
							} else if(num == 2) {
								_this.detail_to_stock = [];
								$(_this.$refs.detail_to_stock).html("");
								$.each(data.response.result, function(k, v) {
									_this.detail_to_stock.push({
										id: v.id,
										text: v.name
									});
								});
								$(_this.$refs.detail_to_stock).select2({
									data: _this.detail_to_stock,
									width: '100%'
								});
								$(_this.$refs.detail_to_stock).prop("disabled", false);
							}
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			fromnowCon: function() {
				var _this = this;
				if($(_this.$refs.from_stock).val() == '') {
					$(_this.$refs.from_stock).removeAttr("data-id");
					$(_this.$refs.from_stock).val("").trigger('change');
				} else if($(_this.$refs.from_stock).attr('data-id') == '') {
					let operatorId = $(_this.$refs.fromDown).find($("[data-id]")).attr('data-id');
					$(_this.$refs.from_stock).attr('data-id', operatorId);
				}
			},
			tonowCon: function() {
				var _this = this;
				if($(_this.$refs.to_stock).val() == '') {
					$(_this.$refs.to_stock).removeAttr("data-id");
					$(_this.$refs.to_stock).val("").trigger('change');
				} else if($(_this.$refs.to_stock).attr('data-id') == '') {
					let operatorId = $(_this.$refs.fromDown).find($("[data-id]")).attr('data-id');
					$(_this.$refs.to_stock).attr('data-id', operatorId);
				}
			},
			// 相差几小时
			getExcgHours: function(start, end) {
				var ms = end.getTime() - start.getTime();
				if(ms < 0) return 0;
				return Math.floor(ms/1000/60/60);
			},
			innitTable: function() {
				let _this = this;
				$(_this.$refs.purchaselist).bootstrapTable("destroy");
				$(_this.$refs.purchaselist).bootstrapTable({
					pageNumber: 1,
					pageSize: 13,
					pageList: [],
					pagination: true,
					ajax: function(params) {
						_this.getExchangeStockList(params);
					},
					sidePagination: "server",
					columns: [{
						field: "number",
						title: "库存调拨单号",
						width: "13%"
					}, {
						field: "create_time",
						title: "调拨日期",
						width: "9%"
					}, {
						field: "shop_name",
						title: "调出门店",
						width: "10%"
					}, {
						field: "from_stock_name",
						title: "调出仓库",
						width: "8%"
					}, {
						field: "to_shop_name",
						title: "调入门店",
						width: "10%"
					}, {
						field: "to_stock_name",
						title: "调入仓库",
						width: "8%"
					}, {
						field: "allocation_num",
						title: "调拨数量",
						width: "8%"
					}, {
						field: "buyingprice_total",
						title: "调拨总额",
						width: "8%"
					}, {
						field: "admin_name",
						title: "操作人",
						width: "8%"
					}, {
						title: "操作",
						width: "11%",
						events: {
							'click .detail': function(e, value, row) {
								_this.editVisible = false;
								_this.getDetail(row.id);
							},
							'click .edit': function(e, value, row) {
								if(_this.getExcgHours(new Date(row.create_time), new Date()) >= '48') {
									layer.msg('调拨单已超过48小时，无法修改');
								} else {
									_this.editVisible = true;
									_this.getDetail(row.id);
								}
							},
							'click .del': function(e, value, row) {
								if(_this.getExcgHours(new Date(row.create_time), new Date()) >= '48') {
									layer.msg('调拨单已超过48小时，无法删除');
								} else {
									layer.confirm('删除后不可恢复，确定删除吗？', {
										btn: ['确定', '取消']
									}, function() {
										_this.delExcgGoods(row.id);
									});
								}
							}
						},
						formatter: function(value, row, index) {
							var operStr = '<span class="text-orange detail">详情</span>&nbsp;&nbsp;'
							if (_this.hasEditPrivilege) {
								operStr += '<span class="text-orange edit">修改</span>&nbsp;&nbsp;'
							}
							if (_this.hasDelPrivilege) {
								operStr += '<span class="text-orange del">删除</span>'
							}
							return operStr
						}
					}],
					// data: _this.purchase_list
				});
			},
			// 获取采购入库列表
			getExchangeStockList: function(params) {
				//debugger;
				let _this = this,
					from_shop_id = $(_this.$refs.fromShop).val(),
					to_shop_id = $(_this.$refs.toShop).val(),
					to_stock_id = "",
					from_stock_id = "",
					pageNumber = 1;
				
				if(typeof($(_this.$refs.to_stock).attr("data-id")) != 'undefined' && $(_this.$refs.to_stock).attr("data-id") != "") {
					to_stock_id = $(_this.$refs.to_stock).attr("data-id");
				}
				if(typeof($(_this.$refs.from_stock).attr("data-id")) != 'undefined' && $(_this.$refs.from_stock).attr("data-id") != "") {
					from_stock_id = $(_this.$refs.from_stock).attr("data-id");
				}
				if(params.data.offset != 0) {
					pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
				}
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"page": pageNumber,
							"page_size": params.data.limit,
							"from_shop_id": from_shop_id,
							"to_shop_id": to_shop_id,
							"to_stock_id": to_stock_id,			//调入仓库id
							"from_stock_id": from_stock_id,		//调出仓库id
							"start_time": _this.startTime,	//开始时间(时间戳)
							"end_time": _this.endTime		//结束时间(时间戳)
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "stock/getExchangeStockList",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							params.success({
								total: data.response.result.total,
								rows: data.response.result.rows
							});
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							layer.msg(data.response.error_msg);
							params.success({
								total: 0,
								rows: 0
							});
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 删除调拨单
			delExcgGoods: function(id) {
				let _this = this;
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"id": id,
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "stock/delExchangeStock",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						layer.closeAll();
						if(data.response.result_code == "true") {
							layer.msg(data.response.error_msg);
							$(_this.$refs.purchaselist).bootstrapTable('refresh');
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.closeAll();
						layer.msg("出错啦");
					}
				});
			},
			// 获取库存调拨详情
			getDetail: function(id) {
				let _this = this;
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"id": id,
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				layer.load(0, {
					shade: [0.1, '#ececec'] //0.1透明度的白色背景
				});
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "stock/getExchangeStockDetail",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						layer.closeAll();
						if(data.response.result_code == "true") {
							let to_stock_id = data.response.result.to_stock_id;
							let to_stock_name = data.response.result.to_stock_name;
							let from_stock_id = data.response.result.from_stock_id;
							let from_stock_name = data.response.result.from_stock_name;

							_this.pagetitle = "库存调拨详情";
							_this.theDetail = data.response.result;
							_this.visible = false;

							_this.detail_list = [];
							$.each(data.response.result.detail, function(k, v) {
								_this.detail_list.push({
									buyingprice: v.buyingprice,
									buyingprice_total: v.buyingprice_total,
									goods_name: v.goods_name,
									goods_type_name: v.goods_type_name,
									goods_unit_name: v.goods_unit_name,
									id: v.id,
									merchant_goods_id: v.merchant_goods_id,
									quantity: v.quantity,
									remain_total: v.remain_total,
									remain_total_init: parseInt(v.quantity) + parseInt(v.remain_total),
									remain_total_show: v.remain_total,
									remark: v.remark,
								});
							});
							_this.innitDetailTable();
							if(!_this.editVisible) {
								$(_this.$refs.detaillist).bootstrapTable('hideColumn', 'op'); // 隐藏操作列
								$(_this.$refs.detaillist).bootstrapTable('hideColumn', 'remain_total_show');
							}

							$(_this.$refs.detailshop).select2("val", [data.response.result.from_shop_id]);
							$(_this.$refs.detailshop).prop("disabled", true);
							$(_this.$refs.detail_to_shop).select2("val", [data.response.result.to_shop_id]);
							$(_this.$refs.detail_to_shop).prop("disabled", true);

							$(_this.$refs.detail_to_stock).html("");
							$(_this.$refs.detail_to_stock).append("<option value='" + to_stock_id + "'>" + to_stock_name + "</option>").select2({
								"width": "100%"
							}).select2("val", [to_stock_id]);
							$(_this.$refs.detail_to_stock).prop("disabled", true);

							$(_this.$refs.detail_from_stock).html("");
							$(_this.$refs.detail_from_stock).append("<option value='" + from_stock_id + "'>" + from_stock_name + "</option>").select2({
								"width": "100%"
							}).select2("val", [from_stock_id]);
							
							$(_this.$refs.detail_from_stock).prop("disabled", true);

							// 备注
							_this.allot_remark = data.response.result.remark;
							if (_this.editVisible) {
								$(_this.$refs.allot_remark).prop('disabled', false);
							}else {
								$(_this.$refs.allot_remark).prop('disabled', true);
							}

							// $(_this.$refs.detailsupplier).select2("val", [data.response.result.data.supplier_id - 0]);
							// $(_this.$refs.detailsupplier).prop("disabled", true); //不可用
							_this.showNumandTime = true;
							_this.showDet = true;
							_this.showdetail = true;
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						// layer.closeAll();
						layer.msg("出错啦");
					}
				});
			},
			// 初始化门店输入框
			innitShopInput: function() {
				let _this = this;
				
				let shopDatas = [];
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"page": "1",
							"page_size": "0",
							"name": "",
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);

				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							$.each(data.response.result, function(k, v) {
								shopDatas.push({ id: v.id, text: v.name });
							});
							shopDatas.shift();
							// 调出门店
							$(_this.$refs.fromShop).select2({
								data: shopDatas,
								allowClear: true,
								minimumResultsForSearch: -1,
								language: "zh-CN",
								width: '100%'
							}).on("select2:select", function(e) {
								let $from_stock = $(_this.$refs.from_stock);
								$(_this.$refs.from_stock).removeAttr("data-id");
								$(_this.$refs.from_stock).val("").trigger('change');
								$from_stock.bsSuggest("destroy");
								_this.loadStockListCustom(e.params.data.id, function(result) {
									_this.from_stock.value = [];
									$.each(result, function(k, v) {
										_this.from_stock.value.push({
											name: v.name,
											id: v.id
										});
									});
									_this.innitFromStock();
								});
							});
							// 默认选中门店
							$(_this.$refs.fromShop).val('').trigger('change');
							// 调入门店
							$(_this.$refs.toShop).select2({
								data: shopDatas,
								allowClear: true,
								minimumResultsForSearch: -1,
								language: "zh-CN",
								width: '100%'
							}).on("select2:select", function(e) {
								let $to_stock = $(_this.$refs.to_stock);
								$(_this.$refs.to_stock).removeAttr("data-id");
								$(_this.$refs.to_stock).val("").trigger('change');
								$to_stock.bsSuggest("destroy");
								_this.loadStockListCustom(e.params.data.id, function(result) {
									_this.to_stock.value = [];
									$.each(result, function(k, v) {
										_this.to_stock.value.push({
											name: v.name,
											id: v.id
										});
									});
									_this.innitToStock();
								});
							});
							// 默认选中门店
							$(_this.$refs.toShop).val('').trigger('change');

							// 默认门店后请求调出仓库
							let $from_stock = $(_this.$refs.from_stock);
							$from_stock.bsSuggest("destroy");
							_this.loadStockListCustom($(_this.$refs.fromShop).val(), function(result) {
								_this.from_stock.value = [];
								$.each(result, function(k, v) {
									_this.from_stock.value.push({
										name: v.name,
										id: v.id
									});
								});
								_this.innitFromStock();
								$('#from_stock').prop("disabled", false);
							});
							// 默认门店后请求调入仓库
							let $to_stock = $(_this.$refs.to_stock);
							$to_stock.bsSuggest("destroy");
							_this.loadStockListCustom($(_this.$refs.toShop).val(), function(result) {
								_this.to_stock.value = [];
								$.each(result, function(k, v) {
									_this.to_stock.value.push({
										name: v.name,
										id: v.id
									});
								});
								_this.innitToStock();
								$('#to_stock').prop("disabled", false);
							});

							// 获取列表
							_this.innitTable();

							// 初始化调入、调出门店
							_this.detailshop = shopDatas;
							$(_this.$refs.detailshop).select2({
								data: _this.detailshop,
								width: '100%'
							});
							$(_this.$refs.detail_to_shop).select2({
								data: _this.detailshop,
								width: '100%'
							});
							// 选择调出门店
							$(_this.$refs.detailshop).on("select2:select", function(e) {
								let id = e.params.data.id;
								if(_this.detail_list.length > 0) { //已选择商品
									layer.confirm('修改门店，上次添加商品数据将不保存，确定修改？', {
										btn: ['确定', '取消'], //按钮
										title: ['提示', true]
									}, function() {
										layer.closeAll();
										_this.detail_list = [];
										_this.showDetailTable = false;
										$(_this.$refs.detaillist).bootstrapTable('destroy');
										_this.preshopid = id;
									}, function() {
										layer.closeAll();
										$(_this.$refs.detailshop).select2("val",[_this.preshopid]);
										return;
									});
								} else {
									_this.preshopid = id;
								}
								_this.loadStockList(id, 1);
							});
							// 选择调入门店
							$(_this.$refs.detail_to_shop).on("select2:select", function(e) {
								let id = e.params.data.id;
								if(_this.detail_list.length > 0) { //已选择商品
									layer.confirm('修改门店，上次添加商品数据将不保存，确定修改？', {
										btn: ['确定', '取消'], //按钮
										title: ['提示', true]
									}, function() {
										layer.closeAll();
										_this.detail_list = [];
										_this.showDetailTable = false;
										$(_this.$refs.detaillist).bootstrapTable('destroy');
										_this.preshopid = id;
									}, function() {
										layer.closeAll();
										$(_this.$refs.detail_to_shop).select2("val",[_this.preshopid]);
										return;
									});
								} else {
									_this.preshopid = id;
								}
								_this.loadStockList(id, 2);
							});

						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});

			},
			// 初始化调出仓库
			innitFromStock: function() {
				let _this = this;
				let $from_stock = $(_this.$refs.from_stock);
				$from_stock.bsSuggest({
					data: _this.from_stock,
					ignorecase: true,
					showHeader: false,
					showBtn: false, //不显示下拉按钮
					delayUntilKeyup: true, //获取数据的方式为 firstByUrl 时，延迟到有输入/获取到焦点时才请求数据
					idField: "id",
					keyField: "name",
					effectiveFields: ["name"],
					inputWarnColor: "white", //输入框内容不是下拉列表选择时的警告色
				}).on('onSetSelectValue', function(e, keyword, data) {
					// console.log('onSetSelectValue: ', keyword, data);
				})
			},
			// 初始化调入仓库
			innitToStock: function() {
				let _this = this;
				let $to_stock = $(_this.$refs.to_stock);
				$to_stock.bsSuggest({
					data: _this.to_stock,
					ignorecase: true,
					showHeader: false,
					showBtn: false, //不显示下拉按钮
					delayUntilKeyup: true, //获取数据的方式为 firstByUrl 时，延迟到有输入/获取到焦点时才请求数据
					idField: "id",
					keyField: "name",
					effectiveFields: ["name"],
					inputWarnColor: "white", //输入框内容不是下拉列表选择时的警告色
				}).on('onSetSelectValue', function(e, keyword, data) {
					// console.log('onSetSelectValue: ', keyword, data);
				});
			},
			// 初始化日期插件
			innitDate: function() {
				let _this = this;
				$(_this.$refs.time).daterangepicker({
                    timePicker: true,
                    timePickerIncrement: 1,
                    timePicker12Hour: false,
					buttonClasses: ['btn btn-default'],
					applyClass: 'btn-small btn-orange',
					cancelClass: 'btn-small btn-gray',
					startDate: _this.IntstartTime,
					endDate: _this.IntendTime
				}, function(start, end, label) {
					_this.startTime = start.format('YYYY-MM-DD HH:mm');
					_this.endTime = end.format('YYYY-MM-DD HH:mm');
				});
			},
			//清空日期
			clearDate: function() {
				this.startTime = "";
				this.endTime = "";
			},
			//点击“查询”按钮
			queryList: function() {
				this.innitTable();
			},
			// 点击“新增库存调拨单”
			addExchangeStock: function() {
				let _this = this;
				//清空详情页数据
				_this.theDetail = {};
				_this.detail_list = [];
				$(_this.$refs.detaillist).bootstrapTable('destroy');
				_this.visible = true;
				_this.editVisible = false;
				_this.pagetitle = "新增库存调拨单";
				_this.showDetailTable = false;
				_this.showNumandTime = false;
				_this.showDet = false;

				// $(_this.$refs.detailsupplier).val("null").trigger("change"); //清空选项
				// $(_this.$refs.detailsupplier).prop("disabled", false); //可用
				$(_this.$refs.detail_to_stock).html("");
				$(_this.$refs.detail_to_stock).val("null").trigger("change"); //清空选项
				$(_this.$refs.detail_to_stock).prop("disabled", true);	// 不可用
				// $(_this.$refs.detail_to_stock).prop("disabled", false); //可用
				// 默认门店仓库
				$(_this.$refs.detailshop).val("null").trigger("change"); //清空选项
				$(_this.$refs.detailshop).prop("disabled", false); //可用
				$(_this.$refs.detailshop).val(_this.detailshop[0].id).trigger("change");
				$(_this.$refs.detail_to_shop).val("null").trigger("change"); //清空选项
				$(_this.$refs.detail_to_shop).prop("disabled", false); //可用
				// $(_this.$refs.detail_to_shop).val(_this.detailshop[0].id).trigger("change");
				$(_this.$refs.detail_to_stock).prop("disabled", false);
				_this.loadStockList(this.detailshop[0].id, 1);
				_this.loadStockList(this.detailshop[0].id, 2);

				$(_this.$refs.detail_from_stock).html("");
				$(_this.$refs.detail_from_stock).val("null").trigger("change"); //清空选项
				$(_this.$refs.detail_from_stock).prop("disabled", true);	// 不可用
				// $(_this.$refs.detail_from_stock).prop("disabled", false); // 可用

				// 默认设置为0.00
				_this.$set(_this.theDetail, 'buyingprice_total', '0.00');
				// 默认设置为总仓
				_this.$set(_this.theDetail, 'store_name', '总仓');
				// 备注
				_this.allot_remark = '';
				$(_this.$refs.allot_remark).prop('disabled', false);

				_this.showdetail = true;
			},
			// 初始化采购进详情列表
			innitDetailTable: function(pageNumber) {
				let _this = this;
				let actionEvents = {
					'click .delete': function(e, value, row, index) {
						layer.confirm("确定删除该商品吗？", {
							btn: ['确定', '取消'], //按钮
						}, function() {
							if(!_this.visible) {
								_this.delDetExcgGoods(row.id);
								let depositeData = [];
								for(let i = 0; i < _this.detail_list.length; i++) {
									if(_this.detail_list[i].id != row.id) {
										depositeData.push(_this.detail_list[i]);
									}
								}
								_this.detail_list = depositeData;

								// 刷新滚动条不变
								let scollPostion = $('.el-tabs__content').scrollTop();
								_this.innitDetailTable($(_this.$refs.detaillist).bootstrapTable('getOptions').pageNumber);
								$('.el-tabs__content').scrollTop(scollPostion);
								
								_this.updatePrice();
								layer.closeAll();
								return;
							}
							let depositeData = [];
							for(let i = 0; i < _this.detail_list.length; i++) {
								if(_this.detail_list[i].merchant_goods_id != row.merchant_goods_id) {
									depositeData.push(_this.detail_list[i]);
								}
							}
							_this.detail_list = depositeData;
							
							// 刷新滚动条不变
							let scollPostion = $('.el-tabs__content').scrollTop();
							_this.innitDetailTable($(_this.$refs.detaillist).bootstrapTable('getOptions').pageNumber);
							$('.el-tabs__content').scrollTop(scollPostion);

							layer.closeAll();
						});

					},
					'click .editableicon': function(e, value, row, index) {
						$(this).prev().addClass("editableinput-focus");
						$(this).prev().attr("contenteditable", true);
						$(this).addClass("editableiconend");
						$(this).prev().focus();

					},
					'keypress .editableinput': function(e, value, row, index) {
						if(event.keyCode == "13") {
							$(this).blur();
						}

					},
					'blur .editableinput': function(e, value, row, index) {
						$(this).removeClass("editableinput-focus");
						$(this).attr("contenteditable", false);
						$(this).next().removeClass("editableiconend");
						if($(e.target).hasClass("quantity")) {
							// 数量编辑
							let arr = $(this).text().split('*');
							let num = 1;
							$.each(arr, function(k, v) {
								num *= v;
							});
							num += '';
							if(isNaN(num)) {
								layer.msg("请输入数字");
								$(this).text(value);
								return;
							} else if(num <= 0) {
								layer.msg("数量需大于0");
								$(this).text(value);
								return;
							} else if(num > Number(row.remain_total_init)) {
								layer.msg("库存不足");
								$(this).text(value);
								return;
							}
							if(num.split('.')[1] && num.split('.')[1].length > '2') {
								num = new Big(num).toFixed(2);
							}
							for(let i = 0; i < _this.detail_list.length; i++) {
								if(_this.visible) {
									// 新增
									if(_this.detail_list[i].merchant_goods_id == row.merchant_goods_id) {
										_this.detail_list[i].quantity = num;
										_this.detail_list[i].remain_total = row.remain_total_init - num;
										// 合计价
										_this.detail_list[i].buyingprice_total = parseFloat(num) * (parseFloat(_this.detail_list[i].buyingprice) * 1000) / 1000;
									}
								} else {
									if(_this.detail_list[i].id == row.id) {
										_this.detail_list[i].quantity = num;
										_this.detail_list[i].remain_total = row.remain_total_init - num;
										// 合计价
										_this.detail_list[i].buyingprice_total = parseFloat(num) * (parseFloat(_this.detail_list[i].buyingprice) * 1000) / 1000;
										
										_this.editExcgGoods(row.id, num, row.remain_total, row.remark);
									}
								}
							}
						}
						// 刷新滚动条不变
						let scollPostion = $('.el-tabs__content').scrollTop();
						$(_this.$refs.detaillist).bootstrapTable('refreshOptions', {});
						$('.el-tabs__content').scrollTop(scollPostion);

						_this.updatePrice();
					},
				};
				$(_this.$refs.detaillist).bootstrapTable('destroy');
				$(_this.$refs.detaillist).bootstrapTable({
					pageNumber: pageNumber || 1,
					pageSize: 10,
					pageList: [],
					pagination: true,
					columns: [{
						field: "goods_name",
						title: "商品名称",
						width: "10%",
						valign: "middle"
					}, {
						field: "goods_unit_name",
						title: "商品单位",
						width: "8%",
						valign: "middle"
					}, {
						field: "goods_type_name",
						title: "商品类型",
						width: "10%",
						valign: "middle"
					}, {
						field: "quantity",
						title: "调拨数量",
						width: "11%",
						valign: "middle",
						events: actionEvents,
						formatter: function(value) {
							if(_this.visible == false) {
								if(_this.editVisible == true) {
									return '<div class="editableinput quantity" contenteditable="false" >' + value + '</div> <a class="editableicon"></a>';
								}
								return value;
							} else {
								if(value - 0 < 1) {
									value = "1"
								}
								return '<div class="editableinput quantity" contenteditable="false" >' + value + '</div> <a class="editableicon"></a>';
							}
						}
					}, {
						field: "remain_total_show",
						title: "调出仓库存剩余",
						width: "10%",
						valign: "middle"
					}, {
						field: "buyingprice",
						title: "进货单价",
						width: "8%",
						valign: "middle"
					}, {
						field: "buyingprice_total",
						title: "进货价合计",
						width: "8%",
						valign: "middle"
					}, {
						field: "remark",
						title: "备注",
						width: "10%",
						events: {
							'blur .remark': function (e, value, row, index) {
								_this.detail_list[index].remark = $.trim($(this).val());
								let remark = $.trim($(this).val())
								if (_this.visible) {// 新增
									$(_this.$refs.detaillist).bootstrapTable("updateCell", { index: index, field: 'remark', value: remark, reinit: false });
								} else {
									_this.editExcgGoods(row.id, row.quantity, row.remain_total, remark);
								}
							}
						},
						formatter: function (value, row, index) {
							if (_this.visible || (!_this.visible && _this.editVisible)) {
								return [
									'<input type="text" placeholder="请输入备注" class="remark" value="' + value + '" />'
								].join('');
							} else {
								return row.remark;
							}
						}
					}, {
						field: "op",
						title: "操作",
						width: "10%",
						valign: "middle",
						events: actionEvents,
						formatter: function(value, row, index) {
							return '<span class="text-orange delete">删除</span>'
						}
					}],
					data: _this.detail_list
				});
				// 隐藏操作列
				// if(_this.visible == true) {
				// 	$(_this.$refs.detaillist).bootstrapTable('hideColumn', 'buyingprice');
				// 	$(_this.$refs.detaillist).bootstrapTable('hideColumn', 'buyingprice_total');
				// }
			},
			// 点击“新增商品”
			addGoods: function() {
				let _this = this,
					from_shop_id = $(_this.$refs.detailshop).val(),
					to_shop_id = $(_this.$refs.detail_to_shop).val();

				let detail_to_stock_id = $(_this.$refs.detail_to_stock).val();

				if ( detail_to_stock_id == "" ) {
					layer.msg("请选择调出仓库");
					return;
				}
				if( from_shop_id == "" ) {
					layer.msg("请选择调出门店");
					return;
				}
				if( to_shop_id == "" ) {
					layer.msg("请选择调入门店");
					return;
				}
				_this.innitSelect();
				_this.innitGoodsTable();
				_this.pop_add_radio = 1
				_this.checkAllGoodsType = false
				_this.choosed_goods_type = [] // 选中的商品类型
				layer.open({
					type: 1,
					title: '添加商品',
					skin: 'layui-layer-rim', // 加上边框
					area: ['820px', '600px'], // 宽高
					content: $(_this.$refs.addgoods)
				});
			},
			// 初始化添加商品弹窗的商品列表
			innitGoodsTable: function(from_shop_id, to_shop_id) {
				let _this = this;
				$(_this.$refs.exchangeStockList).bootstrapTable('destroy');
				$(_this.$refs.exchangeStockList).bootstrapTable({
					pageNumber: 1,
					pageSize: 5,
					pageList: [5,10,20,30,50,100],
					pagination: true,
					height: 350,
					ajax: function(params) {
						_this.getGoodsList(params);
					},
					sidePagination: "server",
					columns: [
						{
							checkbox: true,
							title: "全选"
						},
						{
							field: "goods_type_name",
							title: "类型"
						},
						{
							field: "merchant_goods_name",
							title: "名称"
						},
						{
							field: "merchant_goods_alias",
							title: "别名(调出门店)"
						},
						{
							field: "goods_unit_name",
							title: "单位"
						}
					],
					clickToSelect: true
				});
			},
			closeLayer: function() {
				layer.closeAll();
				this.clearPop();
			},
			// 清空弹窗的值
			clearPop: function() {
				$(this.$refs.goodtype).val("");
				$(this.$refs.goodname).val("");
				$(this.$refs.exchangeStockList).bootstrapTable("destroy");
			},
			// 初始化商品类型选择框
			innitSelect: function() {
				let _this = this;
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);

				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "PublicData/api_getGoodsType",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							_this.goodsType_list.push({
								id: "0",
								text: "全部"
							});
							$.each(data.response.result.data, function(k, v) {
								_this.goodsType_list.push({
									id: v.id,
									text: v.name
								});
							});
							$(_this.$refs.goodtype).select2({
								allowClear: true,
								data: _this.goodsType_list,
								width: '100%'
							});
							_this.goods_type_list = data.response.result.data
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 获取商品列表
			getGoodsList: function(params) {
				let _this = this,
					goods_type = $(_this.$refs.goodtype).val(),
					goods_name = $(_this.$refs.goodname).val(),
					pageNumber = 1;
				let detail_from_stock_id = $(_this.$refs.detail_from_stock).val();
				// let detail_from_stock_id = $(_this.$refs.detail_from_stock).val();
				// if ( detail_to_stock_id == "" ) {
				// 	layer.msg("请选择调出仓库");
				// 	return;
				// }
				if( params.data.offset != 0 ) {
					pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
				}
				let dataJson = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"from_shop_id": $(_this.$refs.detailshop).val(),
							"to_shop_id": $(_this.$refs.detail_to_shop).val(),
							"from_store_id": detail_from_stock_id,
							"goods_type": goods_type,
							"merchant_goods_name": goods_name,
							"page": pageNumber,
							"page_size": params.data.limit
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(dataJson);

				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "stock/getExchangeStockGoods",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							params.success({
								total: data.response.result.total,
								rows: data.response.result.rows
							});
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 点击新增进货商品弹窗的“查询”按钮
			queryGoods: function() {
				$(this.$refs.exchangeStockList).bootstrapTable("destroy");
				this.innitGoodsTable();
			},
			// 点击新增进货商品弹窗的“保存”按钮
			saveGoods: function() {
				let _this = this;
				let add_goods = []
				$.map($(_this.$refs.exchangeStockList).bootstrapTable('getSelections'), function(row) {
					for(let i = 0; i < _this.detail_list.length; i++) {
						if(_this.detail_list[i].merchant_goods_id == row.merchant_goods_id) {
							layer.msg("商品已存在");
							return;
						}
					}

					_this.detail_list.push({ merchant_goods_id: row.merchant_goods_id, to_merchant_goods_id: row.to_merchant_goods_id, goods_name: row.merchant_goods_name, goods_type_name: row.goods_type_name, goods_unit_name: row.goods_unit_name, quantity: "1", remain_total: row.remain_total - 1, remain_total_init: row.remain_total, remain_total_show: row.remain_total, buyingprice: row.buying_price, buyingprice_total: row.buying_price, remark: ''});

					add_goods.push({ merchant_goods_id: row.merchant_goods_id, to_merchant_goods_id: row.to_merchant_goods_id, goods_name: row.merchant_goods_name, goods_type_name: row.goods_type_name, goods_unit_name: row.goods_unit_name, quantity: "1", remain_total: row.remain_total - 1, remain_total_init: row.remain_total, remain_total_show: row.remain_total, buyingprice: row.buying_price, buyingprice_total: row.buying_price, remark: '' });
					layer.msg("成功添加商品");
				});

				_this.showDetailTable = true;
				if (_this.editVisible && add_goods.length > 0) {
					_this.onEditPageAddGoods(add_goods)
				}else {
					_this.innitDetailTable();

					//更新价格
					_this.updatePrice();
				}
			},
			// 更新进货总价
			updatePrice: function() {
				let _this = this;
				let totalPrice = 0;
				if(typeof($(_this.$refs.detaillist).bootstrapTable("getData")) == 'undefined') {
					_this.theDetail.buyingprice_total = totalPrice;
					return;
				}
				$.each($(_this.$refs.detaillist).bootstrapTable("getData"), function(i, item) {
					totalPrice = totalPrice + (item.quantity - 0) * (item.buyingprice - 0);
				});
				//				_this.theDetail.amount = totalPrice;
				_this.$set(_this.theDetail, 'buyingprice_total', totalPrice);
			},
			// 点击“全选”商品类型
			handleCheckAllChange(val) {
                this.choosed_goods_type = []
                if (!!val) {
                    this.goods_type_list.forEach(item => {
                        this.choosed_goods_type.push(item.id)
                    })
                }
            },
            // 选择商品类型
            handleCheckedGoodsTypeChange(value) {
                let checkedCount = value.length;
                this.checkAllGoodsType = checkedCount === this.goods_type_list.length;
            },
            // 商品类型选择“保存”
            onGoodsTypeSaveClick() {
            	if (this.choosed_goods_type.length < 1) {
            		layer.msg("请先选择商品类型！")
            		return
            	}
            	this.getGoodsByTypeArr(this.choosed_goods_type)
            },

            // 按照商品类型获取商品列表
			getGoodsByTypeArr: function(type_arr) {
				let _this = this
				let detail_from_stock_id = $(_this.$refs.detail_from_stock).val();
				let dataJson = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"from_shop_id": $(_this.$refs.detailshop).val(),
							"to_shop_id": $(_this.$refs.detail_to_shop).val(),
							"from_store_id": detail_from_stock_id,
							"goods_type": '',
							"goods_type_arr": type_arr,
							"merchant_goods_name": '',
							"page": 0,
							"page_size": 0
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(dataJson);

				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "stock/getExchangeStockGoods",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							let res = data.response.result.rows
							let add_goods = []
							$.map(res, function(row) {
								for(let i = 0; i < _this.detail_list.length; i++) {
									if(_this.detail_list[i].merchant_goods_id == row.merchant_goods_id) {
										layer.msg("商品已存在");
										return;
									}
								}

								_this.detail_list.push({ merchant_goods_id: row.merchant_goods_id, to_merchant_goods_id: row.to_merchant_goods_id, goods_name: row.merchant_goods_name, goods_type_name: row.goods_type_name, goods_unit_name: row.goods_unit_name, quantity: "1", remain_total: row.remain_total - 1, remain_total_init: row.remain_total, remain_total_show: row.remain_total, buyingprice: row.buying_price, buyingprice_total: row.buying_price, remark: '' });
								
								add_goods.push({ merchant_goods_id: row.merchant_goods_id, to_merchant_goods_id: row.to_merchant_goods_id, goods_name: row.merchant_goods_name, goods_type_name: row.goods_type_name, goods_unit_name: row.goods_unit_name, quantity: "1", remain_total: row.remain_total - 1, remain_total_init: row.remain_total, remain_total_show: row.remain_total, buyingprice: row.buying_price, buyingprice_total: row.buying_price, remark: '' });
								layer.msg("成功添加商品");
							});
							_this.showDetailTable = true;
							if (_this.editVisible && add_goods.length > 0) {
								_this.onEditPageAddGoods(add_goods)
							}else {
								_this.innitDetailTable();

								//更新价格
								_this.updatePrice();
							}
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},

			// 提交库存调拨单
			submitPurchase: function() {
				let _this = this,
					from_shop_id = $(_this.$refs.detailshop).val(),
					to_shop_id = $(_this.$refs.detail_to_shop).val();
				let detail_to_stock_id = $(_this.$refs.detail_to_stock).val();
				let detail_from_stock_id = $(_this.$refs.detail_from_stock).val();
				if ( detail_to_stock_id == "" ) {
					layer.msg("请选择调出仓库");
					return;
				}
				if ( detail_from_stock_id == "" ) {
					layer.msg("请选择调入仓库");
					return;
				}
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"from_shop_id": from_shop_id,
							"to_shop_id": to_shop_id,
							"to_stock_id": detail_to_stock_id,
							"from_stock_id": detail_from_stock_id,
							"remark": _this.allot_remark,
							"goods": _this.detail_list
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				layer.load(0, {
					shade: [0.1, '#ececec'] //0.1透明度的白色背景
				});
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "stock/addExchangeStock",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						layer.closeAll();
						if(data.response.result_code == "true") {
							$('#allotSave').prop('disabled', true);
							layer.msg("新增成功！");
							//显示时间和单号
							_this.$set(_this.theDetail, "number", data.response.result.number);
							_this.$set(_this.theDetail, "create_time", _this.getNowFormatDate());
							_this.showNumandTime = true;
							$(_this.$refs.purchaselist).bootstrapTable("refresh");
							//							_this.theDetail.number = data.response.result.data.number;
							//							_this.theDetail.create_time = _this.getNowFormatDate();
							//返回列表页刷新列表
							setTimeout(function() {
								_this.showdetail = false;
								_this.showNumandTime = false;
								$('#allotSave').prop('disabled', false);
							}, 2000);
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.closeAll();
						layer.msg("出错啦");
					}
				});
			},
			// 修改调拨数量
			editExcgGoods: function(id, quantity, remain_total, remark) {
				let _this = this;
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"id": id,
							"quantity": quantity,
							"remain_total": remain_total,
							"remark": remark
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "stock/modifyExchangeStockDetail",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							layer.msg(data.response.error_msg);
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 删除详情页商品
			delDetExcgGoods: function(id) {
				let _this = this;
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"id": id
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "stock/delExchangeStockDetail",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							layer.msg(data.response.error_msg);
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 返回列表
			backList: function() {
				this.showdetail = false;
				if(!this.visible && this.editVisible) {
					$(this.$refs.purchaselist).bootstrapTable('refresh');
				}
			},

			// 修改备注
			onRemarkBlur() {
				if (this.editVisible) {
					let _this = this;
					let datas = {
						"header": Vue.request_header,
						"request": {
							"version": Vue.version,
							"param": {
								"id": _this.theDetail.id,
								"remark": _this.allot_remark, // 备注
								"add_goods": []
							}
						},
						"comment": ""
					};
					let datas2 = JSON.stringify(datas);
					$.ajax({
						type: "post",
						dataType: "json",
						url: Vue.ctUrl + "Stock/editExchangeStock",
						crossDomain: true,
						xhrFields: {
							withCredentials: true
						},
	                    data: datas2,
						success: function(data) {
							if(data.response.result_code == "true") {
								layer.msg("修改成功！");
							} else {
								Vue.timeoutfun(data.response.result_status, _this);
								layer.msg(data.response.error_msg);
							}
						},
						error: function(err) {
							layer.msg("出错啦");
						}
					});
				}
			},

			// 修改页面新增商品
			onEditPageAddGoods(goods) {
				let _this = this;
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"id": _this.theDetail.id,
							"remark": _this.allot_remark, // 备注
							"add_goods": goods
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "Stock/editExchangeStock",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							_this.getDetail(_this.theDetail.id)
						} else {
							_this.getDetailTableForShow(_this.theDetail.id)
							Vue.timeoutfun(data.response.result_status, _this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},

			// 获取详情的商品表格
			getDetailTableForShow(id) {
				let _this = this;
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"id": id,
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				layer.load(0, {
					shade: [0.1, '#ececec'] //0.1透明度的白色背景
				});
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "stock/getExchangeStockDetail",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							_this.detail_list = [];
							$.each(data.response.result.detail, function(k, v) {
								_this.detail_list.push({
									buyingprice: v.buyingprice,
									buyingprice_total: v.buyingprice_total,
									goods_name: v.goods_name,
									goods_type_name: v.goods_type_name,
									goods_unit_name: v.goods_unit_name,
									id: v.id,
									merchant_goods_id: v.merchant_goods_id,
									quantity: v.quantity,
									remain_total: v.remain_total,
									remain_total_init: parseInt(v.quantity) + parseInt(v.remain_total),
									remain_total_show: v.remain_total,
									remark: v.remark,
								});
							});
							_this.innitDetailTable();
							if(!_this.editVisible) {
								$(_this.$refs.detaillist).bootstrapTable('hideColumn', 'op'); // 隐藏操作列
								$(_this.$refs.detaillist).bootstrapTable('hideColumn', 'remain_total_show');
							}
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						// layer.closeAll();
						layer.msg("出错啦");
					}
				});
			},

			// 获取当前时间
			getNowFormatDate: function() {
				var date = new Date();
				var seperator1 = "-";
				var seperator2 = ":";
				var month = date.getMonth() + 1;
				var strDate = date.getDate();
				if(month >= 1 && month <= 9) {
					month = "0" + month;
				}
				if(strDate >= 0 && strDate <= 9) {
					strDate = "0" + strDate;
				}
				var currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate +
					" " + date.getHours() + seperator2 + date.getMinutes() +
					seperator2 + date.getSeconds();
				return currentdate;
			},
			// 获取导出设置
			getExportSet: function() {
				let _this = this;
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"report_type": "stock/exchangeStockExport"
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "FinanceReport/getExportSet",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							if(data.response.result) {
								_this.export_checkModel = data.response.result.export_fields;
								_this.export_type = data.response.result.export_type;
							} else {
								_this.export_checkModel = _this.export_checkData;
								_this.export_type = 1;
							}
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});

				// 弹窗
				layer.confirm('', {
					skin: 'add_printer_area',
					type: 1,
					btn: ['确定', '取消'], // 按钮
					title: ['导出设置', true],
					area: ['830px', ''], // 宽高
					content: $(_this.$refs.export_alert)
				}, function() {
					_this.exportDetail();
				});
			},
			// 导出字段全选
			exportCheckedAll: function() {
				let _this = this;
				_this.export_allcheck = _this.c_export_allcheck;
				if(!_this.export_allcheck) { // 实现全选
					_this.export_checkModel = [];
					_this.export_checkData.forEach(function(item) {
						_this.export_checkModel.push(item);
					});
				} else { // 实现反选
					_this.export_checkModel = [];
				}
			},
			// 导出
			exportDetail: function() {
				let export_fields = JSON.stringify(this.export_checkModel);
				window.location.href = Vue.ctUrl + "stock/exchangeStockExport?" +
					"id=" + this.theDetail.id +
					"&export_fields=" + export_fields +
					"&export_type=" + this.export_type;
				layer.msg("导出成功！");
				layer.closeAll();
			}
		}
	}
</script>

<style lang="less">
	.exchange-stock {
        .editinput {
            position: relative;
            display: block;
            width: 75%;
            float: left;
            border: none;
            outline: 0;
            box-shadow: none;
            margin-left: 0;
            margin-right: 0;
            resize: none;
            height: 20px;
            line-height: 20px;
            text-align: center;
            word-break: break-all;
            padding: 0!important;
        }
        .editicon {
            width: 32px;
            height: 32px;
            background: url(../../assets/images/editstart.png) no-repeat center;
            background-size: 46%!important;
            display: block;
            float: right;
            margin-top: -6px;
            margin-bottom: -6px;
        }
        .editiconend {
            background: url(../../assets/images/editnote.png) no-repeat center;
        }
		.form-control2 {
			display: inline-block;
		    width: 100%;
		    height: 34px;
		    padding: 6px 12px;
		    font-size: 14px;
		    line-height: 1.42857143;
		    color: #555;
		    background-color: #fff;
		    background-image: none;
		    border: 1px solid #ccc;
		    border-radius: 4px;
		    -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
		    box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
		    -webkit-transition: border-color ease-in-out .15s,-webkit-box-shadow ease-in-out .15s;
		    -o-transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
		    transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s
		}
		.text-orange {
			color: #009af0;
			cursor: pointer;
		}
		.text-red {
			color: red;
		}
		.table-responsive {
			width: 100%;
			padding: 0;
			table {
				table-layout: fixed;
				word-wrap: break-word;
			}
		}
		.detail-panel {
			.col-md-1,
			.col-md-3,
			.col-md-12 {
				padding-left: 0;
			}
			.col-md-12 {
				height: 40px;
				line-height: 40px;
				font-size: 14px;
			}
			.gray-head {
				width: 100%;
				min-height: 200px;
				background-color: #f3f3f3;
				border-top: 8px solid #d7d7d7;
				margin-top: 10px;
				.page-title {
					height: 30px;
					margin-top: 10px;
					line-height: 30px;
					font-size: 20px;
					text-align: center;
				}
				.comment {
					margin: 20px 0;
					line-height: 22px;
					font-size: 12px;
					color: #009af0;
					text-align: center;
				}
				.gray-center {
					overflow: hidden;
					width: 92%;
					margin: 0 0 30px 5%;
					.col-md-3 {
						width: 230px;
					}
				}
			}
			.title {
				height: 50px;
				line-height: 50px;
				font-size: 16px;
				text-align: center;
			}
			.add-goods {
				width: 100%;
				height: 100%;
				padding: 20px 30px;
				display: none;
				#good-name {
					margin-top: 5px;
					border: 1px solid #FF6700;
				}
				.btns {
					margin-top: 10px;
					position: absolute;
					bottom: 30px;
				}
			}
		}
		.querytxt {
			padding-left: 0;
			margin: 2px 0 0 -36px;
		}
		.set-export {
			padding: 0 20px 20px;
			h3 {
				font-size: 16px;
			}
			li {
				float: left;
				width: 20%;
			}
		}
		.add-goods {
			.el-radio-group {
				margin-bottom: 15px;
			}
			.checkbox-wrapper {
				max-height: 350px;
				overflow-y: auto
			}
			.el-checkbox {
				width: 200px;
				margin: 10px;
			}
			.pop-save {
				margin: 0 50px 0 200px;
			}
        }
	}
</style>